module.exports = __webpack_public_path__ + "static/media/anzac-floorplan.9d8028bd.png";